import { Component } from '@angular/core';
import { ComDureeComponent } from '@kv-common-components/kv-common-components';

@Component({
    selector: 'app-duree-component',
    templateUrl: './duree.component.html',
    styleUrls: ['./duree.component.css'],
})
export class DureeComponent extends ComDureeComponent {
    constructor() {
        super();
    }
}
